import { render, staticRenderFns } from "./LanguagePredictionResult.vue?vue&type=template&id=f009f796&"
import script from "./LanguagePredictionResult.vue?vue&type=script&lang=js&"
export * from "./LanguagePredictionResult.vue?vue&type=script&lang=js&"
import style0 from "./LanguagePredictionResult.vue?vue&type=style&index=0&id=f009f796&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports